// extracted by mini-css-extract-plugin
export default {"link":"styles_link__kIJte","box":"styles_box__tomtq","image":"styles_image__vH8z5","content":"styles_content__sBVWH"};